import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { ApiError } from '../../../utils/Api';
import { appsGetQueryKey } from '../apps.api';
import { ScopeModel } from '../types';

import { CreateScopeParams, UpdateScopeParams, useScopesService } from './scopes.service';

const scopesGetQueryKey = 'get-scope';

export const useScope = (scopeId: string, appId: string) => {
  const scopesService = useScopesService();

  return useQuery({
    queryKey: [scopesGetQueryKey, { appId, scopeId }],
    queryFn: () => scopesService.getScope({ appId, scopeId }),
  });
};

export const useCreateScope = () => {
  const scopesService = useScopesService();
  const queryClient = useQueryClient();

  return useMutation<ScopeModel, AxiosError<ApiError>, CreateScopeParams>({
    mutationFn: (params: CreateScopeParams) => scopesService.createScope(params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [appsGetQueryKey] }),
  });
};

export const useUpdateScope = () => {
  const scopesService = useScopesService();
  const queryClient = useQueryClient();

  return useMutation<ScopeModel, AxiosError<ApiError>, UpdateScopeParams>({
    mutationFn: (params: UpdateScopeParams) => scopesService.updateScope(params),
    onSuccess: async ({ scopeId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [appsGetQueryKey] }),
        queryClient.invalidateQueries({ queryKey: [scopesGetQueryKey, { scopeId }] }),
      ]);
    },
  });
};
